export default function sendMixPanelEvent({ eventName, eventData = {} }) {
    try {
        MixpanelWrapper.trackEvent(eventName, eventData);
    } catch (e) {
        //
    }
}
